import React from 'react';
import { useTranslation } from 'react-i18next';

const CalendarEmpty = ({
  type = 'empty',
  title,
  message,
  icon,
  action,
  className = '',
}) => {
  const { t } = useTranslation('calendar');

  const defaultContent = {
    empty: {
      icon: '📅',
      title: t('emptyState.noEvents'),
      message: t('emptyState.noEventsMessage'),
    },
    loading: {
      icon: '⏳',
      title: t('emptyState.loading'),
      message: t('emptyState.loadingMessage'),
    },
    error: {
      icon: '⚠️',
      title: t('emptyState.error'),
      message: t('emptyState.errorMessage'),
    },
    noTrainer: {
      icon: '👤',
      title: t('emptyState.noTrainer'),
      message: t('emptyState.noTrainerMessage'),
    },
    noSelection: {
      icon: '📋',
      title: t('emptyState.noSelection'),
      message: t('emptyState.noSelectionMessage'),
    },
  };

  const content = defaultContent[type] || defaultContent.empty;

  return (
    <div className={`calendar-empty ${className}`}>
      <div className="calendar-empty__icon">
        {icon || content.icon}
      </div>

      <div className="calendar-empty__title">
        {title || content.title}
      </div>

      <div className="calendar-empty__message">
        {message || content.message}
      </div>

      {action && (
        <div className="calendar-empty__action">
          {action}
        </div>
      )}
    </div>
  );
};

export default CalendarEmpty;
